
      var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgQuestionIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40,
  viewBox: "0 0 44 44",
  fill: "none"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 22,
  r: 16,
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 2.75,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 30.938,
  r: 2.063,
  fill: "var(--theme-primary, #810ea9)"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M22 24.75v-1.374a4.812 4.812 0 1 0-4.813-4.813",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 2.75,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"40\" height=\"40\" viewBox=\"0 0 44 44\" fill=\"none\">\r\n  <circle cx=\"22\" cy=\"22\" r=\"16\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"2.75\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n  <circle cx=\"22\" cy=\"30.9375\" r=\"2.0625\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n  <path d=\"M22 24.7507V23.3757C24.6579 23.3757 26.8125 21.2211 26.8125 18.5632C26.8125 15.9054 24.6579 13.7507 22 13.7507C19.3421 13.7507 17.1875 15.9054 17.1875 18.5632\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"2.75\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/question-icon.2054fe5d1f6cbc7eb63ddd8717ccb872.svg"),
        {
          React: SvgQuestionIcon,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      